import { IPaginatedResponse } from '@/infra/interfaces/http/http-client';
import { httpClient } from '@/infra/protocols/http';
import { IPodcastDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcast } from '@/modules/podcasts/entities/podcast.entity';
import { PodcastMapper } from '@/modules/podcasts/mappers/podcast.mapper';

export async function getPodcasts(
  params: GetPodcastsService.Params,
): Promise<GetPodcastsService.Response> {
  const response = await httpClient.get<IPodcastDTO[], true>(
    `/v1/projetos/${params.projectId}/podcasts`,
    {
      params: {
        page: params.page,
      },
      paginated: true,
    },
  );

  return {
    ...response,
    data: response.data.map(PodcastMapper.toPresentation),
  };
}

export namespace GetPodcastsService {
  export interface Params {
    page: number;
    projectId: string;
  }

  export type Response = IPaginatedResponse<IPodcast[]>;
}
